export var ProviderChatStatus;
(function (ProviderChatStatus) {
    ProviderChatStatus["Processing"] = "processing";
    ProviderChatStatus["Idle"] = "idle";
})(ProviderChatStatus || (ProviderChatStatus = {}));
//# sourceMappingURL=types.js.map